export default __webpack_public_path__ + "static/media/darkgreen-vaccine.b439d717.svg";